import FormType from '../constants/form-type';
import UiState from '../constants/ui-state';
import LoginComponent from './login-component';
import Login from './forms/login';
import Register from './forms/register';
import ForgotPassword from './forms/forgot-password';
import PlatformDetection from '../infrastructure/platform-detection';

import './login-form.scss';

export default class LoginForm extends LoginComponent {

    constructor(props) {
        super(props);

        Raven.config(this.state.paramModel.sentryUrl, {
            whitelistUrls: [
                /jwf-login\.js/
            ],
            includePaths: [
                /https?:\/\/.+3amlabs\.net/, /https?:\/\/.+join\.me/
            ]
        }).install();

        Raven.setExtraContext({
            user: this.state.paramModel.userLogData,
            instanceId: this.state.paramModel.instanceId
        });
    }

    get formUi() {
        if (this.state.uiState.form.uiState === UiState.initial) {
            return null;
        }
        return this.renderedView;
    }

    get renderedView() {
        switch (this.state.loginModel.formType) {
            case FormType.login:
                return (<Login componentId={this.state.componentId} />);
            case FormType.register:
                return (<Register componentId={this.state.componentId} />);
            case FormType.forgotPassword:
                return (<ForgotPassword componentId={this.state.componentId} />);
            default:
                return null;
        }
    }

    get formClassName() {
        const lang = this.state.paramModel.lang5.substring(0,2);
        const uiState = this.state.uiState.form.uiState;
        let className = `login-component login-form ${PlatformDetection.os.name} ${PlatformDetection.browser.name} ${lang} ${uiState}`;

        this.state.uiState.form.formVariants.map((variant) => {
            className += ` ${variant}`;
        });

        return className;
    }

    render() {
        return (
            <div className='jwf-login'>
                <div className={this.formClassName}>
                    {this.formUi}
                    <div id={this.state.paramModel.clsExecutionArea} className="cls-execution-area"></div>
                </div>
            </div>
        )
    }
};


/** WEBPACK FOOTER **
 ** ./src/components/login-form.jsx
 **/